import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { COMMENT_MAX_LENGTH } from 'const/limits'
import createEmptyRichText from 'components/RichText/utils/createEmptyRichText'
import getCharCount from 'components/RichText/utils/getCharCount'
import trimRichText from 'components/RichText/utils/trim'
import MessageForm from 'components/MessageForm'
import BoardUser from 'routes/Board/User'
import classes from './Message.module.scss'
import {
  MenuItem
} from 'react-bootstrap'
import SendEmailFromCard from './SendEmailFromCard'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import sweetalert from 'sweetalert2'

export function Message ({
  leftSidebar,

  id,
  boardId,
  editingUsers,
  sendEmailFromCardEnabled,

  requestSendMessage,

  onChange,
  onBlur,
}) {
  const intl = useIntl()

  const handleMessageValidate = useCallback(
    ({ message }) => {
      const errors = {}

      const contentCharCount = getCharCount(message)
      if (contentCharCount > COMMENT_MAX_LENGTH) {
        errors.message = intl.formatMessage({ id: 'CARD_COMMENT_TOO_LONG' }, { limit: COMMENT_MAX_LENGTH })
      }

      return errors
    },
    [intl]
  )

  const handleMessageSubmit = useCallback(
    ({ message }) => {
      const contentCharCount = getCharCount(message)

      if (contentCharCount > 0) {
        requestSendMessage({
          cardId: id,
          message: trimRichText(message)
        })
      }
    },
    [id, requestSendMessage]
  )

  let moreEditingUsers = false
  let editingUsersToDisplay = editingUsers

  if (editingUsers.length > 10) {
    moreEditingUsers = editingUsers.length - 10
    editingUsersToDisplay = editingUsers.slice(-10)
  }

  return (
    <div className={classes.message}>
      <MessageForm
        richTextEditorProps={{
          expandOnFocus: true,
          placeholder: intl.formatMessage({ id: 'CARD_COMMENT_HINT' }),
          mentionBoardId: boardId,
          maxLength: COMMENT_MAX_LENGTH,
          saveChanges: 'cardMessage-' + id,
          onBlur,
          submitButton: <FormattedMessage id='CARD_COMMENT_SEND' />,
          sendActions: sendEmailFromCardEnabled ? (
            <MenuItem
              onClick={(event, content, clear) => {
                if (getCharCount(content) > 0) {
                  leftSidebar.push((props) => <SendEmailFromCard {...props} cardId={id} content={content} clearInput={clear} />)
                } else {
                  sweetalert({
                    text: intl.formatMessage({ id: 'CARD_COMMENT_SEND_EMPTY' }),
                    type: 'info'
                  }).catch(sweetalert.noop)
                }
              }}
            >
              <FormattedMessage id='CARD_COMMENT_SEND_EMAIL_FROM_CARD' />
            </MenuItem>
          ) : undefined,
        }}
        form={'cardMessage-' + id}
        initialValues={{
          message: createEmptyRichText()
        }}
        onChange={onChange}
        validate={handleMessageValidate}
        onSubmit={handleMessageSubmit}
      />
      {editingUsers.length > 0 &&
        <div className={classes.editingUsers}>
          <div className={classes.typingIndicator}>
            <div className={classes.typingDot} />
            <div className={classes.typingDot} />
            <div className={classes.typingDot} />
          </div>
          {moreEditingUsers &&
            <div className={`${classes.editingUser} ${classes.moreEditingUsers}`}>
              +{moreEditingUsers}
            </div>
          }
          {editingUsersToDisplay.map(userId =>
            <BoardUser
              key={userId}
              id={userId}
              avatar
              draggable
              defaultMenu
              size={18}
              className={classes.editingUser}
            />
          )}
        </div>
      }
    </div>
  )
}

Message.propTypes = {
  intl: PropTypes.object.isRequired,

  id: PropTypes.number.isRequired,
  boardId: PropTypes.number.isRequired,
  editingUsers: PropTypes.array.isRequired,

  requestSendMessage: PropTypes.func.isRequired,

  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
}

export default withLeftSidebar(Message)
